import { render, staticRenderFns } from "./EmailVerification.vue?vue&type=template&id=11b0e815"
import script from "./EmailVerification.vue?vue&type=script&lang=ts"
export * from "./EmailVerification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports